export default __webpack_public_path__ + "image/auth-app-background.jpg";